import * as TYPES from 'constants/ActionTypes';
import { get, keyBy } from 'lodash';
import { handleActions } from 'redux-actions';

const initialState = {
  register: {
    error: null,
    hasError: false,
    initFetching: false,
    initFetched: false,
    perDiemList: [],
    perDiemLocationList: [],
    perDiemTypeList: [],
    perDiemListKeyed: [],
    perDiemLocationListKeyed: [],
    perDiemTypeListKeyed: [],
    approvalLoading: false,
    calculating: false,
    calculatedRecord: null,
    calcError: null,
    calcHasError: false,
  },
};

export default handleActions({
  [TYPES.PERDIEM_INIT_APPROVAL_REQUEST]: state => ({
    ...state,
    initFetching: true,
  }),
  [TYPES.PERDIEM_INIT_APPROVAL_SUCCESS]: (state, action) => {
    const perDiemList = get(action, 'data.perDiemList', []);
    const perDiemLocationList = get(action, 'data.perDiemLocationList', []);
    const perDiemTypeList = get(action, 'data.perDiemTypeList', []);
    const perDiemAmountTypeFixed = get(action, 'data.perDiemAmountTypeFixed');
    return ({
      ...state,
      initFetched: true,
      initFetching: false,
      perDiemList,
      perDiemLocationList,
      perDiemTypeList,
      perDiemListKeyed: keyBy(perDiemList, 'PerDiemID'),
      perDiemLocationListKeyed: keyBy(perDiemLocationList, 'PerDiemLocationID'),
      perDiemTypeListKeyed: keyBy(perDiemTypeList, 'PerDiemTypeID'),
      perDiemAmountTypeFixed,
    });
  },
  [TYPES.PERDIEM_INIT_APPROVAL_FAILURE]: (state, action) => ({
    ...state,
    hasError: true,
    error: action.error,
    fetching: false,
    initFetching: false,
  }),
  [TYPES.PERDIEM_APPROVAL_REQUEST]: state => ({
    ...state,
    approvalError: null,
    hasApprovalError: false,
    approvalLoading: true,
  }),
  [TYPES.PERDIEM_APPROVAL_SUCCESS]: state => ({
    ...state,
    approvalLoading: false,
  }),
  [TYPES.PERDIEM_APPROVAL_FAILURE]: (state, action) => ({
    ...state,
    approvalError: action.error,
    hasApprovalError: true,
    approvalLoading: false,
  }),
  [TYPES.CALCULATE_REQUEST]: state => ({
    ...state,
    calculating: true,
    calcError: null,
    calcHasError: false,
  }),
  [TYPES.CALCULATE_SUCCESS]: (state, action) => ({
    ...state,
    calculating: false,
    calculatedRecord: action.calculatedRecord,
  }),
  [TYPES.CALCULATE_FAILURE]: (state, action) => ({
    ...state,
    calculatedRecord: null,
    calculating: false,
    calcHasError: true,
    calcError: action.error,
  }),
  [TYPES.CALCULATE_RESET]: state => ({
    ...state,
    calculatedRecord: null,
  }),


}, initialState);




// WEBPACK FOOTER //
// ./src/reducers/PerDiem.js